export class AutorisationSpecifique {

	public precisions: string;

	constructor() { 
		 		this.precisions = '';
 
	}
}
